/// <reference path="../../modals/modals.ts" />

namespace OfficeGuy.Inputs {
    export class NavigationAddress {
        static Init() {
            $(document)
                .off("click.og-navigationaddress")
                .on("click.og-navigationaddress", "a.navigationaddress", function () {
                    var $Link = $(this);
                    var $Modal = Modals.ShowHTMLDialog({
                        Title: "ניווט לכתובת",
                        HTML: $(document.createElement('div'))
                            .text("באיזה תוכנה ברצונך לנווט?"),
                        Buttons: [
                            $
                                (document.createElement('a')
                                    .addClass("og-button-ui-action", "og-button-color-default")
                                    .setText("Waze"))
                                .css("vertical-align", "middle")
                                .click(function () {
                                    window.open($Link.data("wazeurl"));
                                    Modals.Hide($Modal);
                                    return true;
                                }),
                            $
                                (document.createElement('input')
                                    .attr("type", "button")
                                    .addClass("og-button-ui-action", "og-button-color-submit")
                                    .val("Google Maps"))
                                .click(function () {
                                    window.open($Link.attr("href"));
                                    Modals.Hide($Modal);
                                    return false;
                                })
                        ]
                    });
                    return false;
                });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.NavigationAddress.Init();
});